// extracted by mini-css-extract-plugin
export var header = "_u6-1";
export var maskBottom = "_u6-6";
export var maskMiddle = "_u6-7";
export var maskTop = "_u6-5";
export var root = "_u6-0";
export var scrollDownButton = "_u6-3";
export var scrollDownButtonHidden = "_u6-4";
export var viewport = "_u6-2";